import { request } from '@/shared/api/request'

export const getKatoChildren = (params) => {
	return request({ url: 'dict/kato', method: 'GET', params })
}
